import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useTranslation } from 'react-i18next'

type DeleteSideStoryDialogProps = {
  onConfirm: () => void
  onOpenChange: (open: boolean) => void
  open: boolean
  storyTitle: string
  submitting: boolean
}

export function DeleteSideStoryDialog({
  onConfirm,
  onOpenChange,
  open,
  storyTitle,
  submitting,
}: DeleteSideStoryDialogProps) {
  const { t } = useTranslation()

  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('story.sideStories.deleteDialog.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('story.sideStories.deleteDialog.body', {
              storyTitle,
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={submitting}>{t('common.cancel')}</AlertDialogCancel>
          <AlertDialogAction disabled={submitting} onClick={onConfirm}>
            {t('story.sideStories.deleteDialog.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
